import { render, staticRenderFns } from "./editruletoorderwt.vue?vue&type=template&id=3cc8f728"
import script from "./editruletoorderwt.vue?vue&type=script&lang=js"
export * from "./editruletoorderwt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports